<template>
  <v-expansion-panel v-model="panel" v-if="$store.getters['rolesUser/getCustomRole'](45)">
    <v-expansion-panel-header class="mt-2">
      BUSCAR PRODUCTOS
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <block v-if="loading"></block>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            Lista de Productos
            <v-icon>mdi-account-search</v-icon>
          </v-tab>
          <v-tab href="#tab-2">
            Edición Masiva
            <v-icon>mdi-pencil-box-multiple</v-icon>
          </v-tab>
          <v-tab href="#tab-3">
            Edicion de ubicaciones
            <v-icon>mdi-warehouse</v-icon>
          </v-tab>
          <v-tab href="#tab-4">
            Margenes de ganancia
            <v-icon>mdi-cash-edit</v-icon>
          </v-tab>
          <v-tab v-if="showExternalProductImagesLoadTab" href="#tab-5">
            Imágenes de productos
            <v-icon>mdi-image-multiple</v-icon>
          </v-tab>
          <v-tab v-if="showExternalProductImagesHistoryTab" href="#tab-6">
            Historial de imágenes
            <v-icon>mdi-history</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
            <v-card flat class="pa-1 position-relative">
              <div class="d-flex filter-btn">
                <v-bottom-sheet v-model="showFilter" inset>
                  <!--template v-slot:activator="{ on, attrs }">
                                                  <v-btn color="orange" dark v-bind="attrs" v-on="on">FILTROS
                                                  </v-btn>
                                              </template-->
                  <v-sheet class="text-center">
                    <v-btn class="mt-6" text color="error" @click="showFilter = !showFilter">Cerrar
                    </v-btn>
                    <v-btn class="mt-6" text color="primary">Filtros</v-btn>
                    <div class="my-3 pa-4">
                      <div>
                        <date-picker label="Desde"></date-picker>
                        <date-picker label="Hasta"></date-picker>
                        <v-select outlined dense :items="['PROVIDER 1', 'PROVIDER 2', 'PROVIDER 3', 'PROVIDER 3']" attach
                          label="Selecciona Proveedor">
                          <template v-slot:item="{ item, attrs, on }">
                            <v-list-item v-bind="attrs" v-on="on">
                              <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-select>
                      </div>

                    </div>

                  </v-sheet>
                </v-bottom-sheet>

              </div>
              <v-card class="pa-4 white component-v-card">
                <v-row class="ma-3">
                  <v-col cols="12" md="3">
                      <v-checkbox v-model="search.showWareHouseAndProviders" label="Mostrar almacenes y proveedores" @change="getAllProducts"></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                      <v-checkbox v-model="search.showAll" label="Mostrar todos los registros" @change="getAllProducts"></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                      <v-checkbox v-model="search.showPrincipalBarCode" label="Mostrar códigos alternos principales" @change="getAllProducts"></v-checkbox>
                  </v-col>
                </v-row>

                <!-- This following table was made just for one business -->
                <!-- Aniimate custom table-->
                <GeneralFilter @loading="loading = $event" :filterEndpoint="$API.products.filterProductSpecialInventoryWithWareHouseAndProviders" 
                    :search="search" @emptyFilter="getAllProducts" @filtered="filterHandlerSpecialInventory"
                    :columnsFilterEndpoint="getAllProducts" :columns.sync="filterColumns" :advancedFilter="true"
                    prefixColumn
                    >
                  <DxDataGrid :data-source="products" key-expr="ID_Item" :show-row-lines="showRowLines"
                    @exporting="onExporting" :show-borders="showBorders" :row-alternation-enabled="rowAlternationEnabled"
                    :column-auto-width="true"
                    >
                    
                    <DxExport :enabled="true" />
                    <DxScrolling row-rendering-mode="virtual" />
                    <DxPaging :page-size="10" />
                    <DxColumn v-if="$store.getters['rolesUser/getCustomRole'](110)" :width="210" cell-template="show-template" caption="Acciones" alignment="center"></DxColumn>
                    <DxColumn data-field="ID_Item" caption="ID Producto"></DxColumn>
                    <DxColumn v-if="search.showPrincipalBarCode" data-field="PrincipalBarCode" caption="Código Alterno Principal"></DxColumn>
                    <DxColumn data-field="ItemName" caption="Nombre del Producto"></DxColumn>
                    <DxColumn data-field="BrandName" caption="Marca"></DxColumn>
                    <DxColumn data-field="FamilyName" caption="Familia"></DxColumn>
                    <DxColumn data-field="CategoryName" caption="Categoría"></DxColumn>
                    <DxColumn data-field="stock" caption="Disponible"></DxColumn>
                    <!--DxColumn data-field="LasPurchasePriceFormatted" caption="Último Costo de Compra"></DxColumn-->
                    <DxColumn data-field="ItemPriceFormatted" caption="Precio de Venta"></DxColumn>
                    <DxColumn v-if="search.showWareHouseAndProviders" data-field="WarehouseName" caption="Almacenes"></DxColumn>
                    <DxColumn v-if="search.showWareHouseAndProviders" data-field="Providers" caption="Proveedores"></DxColumn>
                    <template #show-template="{ data }">
                      <div class="product-actions">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              class="product-action-btn product-action-btn--view"
                              v-bind="attrs"
                              v-on="on"
                              aria-label="Ver detalle del producto"
                              @click.prevent.stop="
                                $store.dispatch('addWindow', {
                                  name: 'ManageProduct',
                                  component: 'ManageProduct',
                                  unique: false,
                                  meta: { product: data.data }
                                })
                              "
                            >
                              <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver detalle del producto</span>
                        </v-tooltip>

                        <v-tooltip bottom v-if="$store.getters['rolesUser/getCustomRole'](255)">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              class="product-action-btn product-action-btn--price"
                              v-bind="attrs"
                              v-on="on"
                              aria-label="Editar lista de precios"
                              @click.prevent.stop="openPriceListEditor(data.data)"
                            >
                              <v-icon small>mdi-currency-usd</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar lista de precios</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              class="product-action-btn product-action-btn--codes"
                              v-bind="attrs"
                              v-on="on"
                              aria-label="Ver códigos alternos"
                              @click.prevent.stop="showCodesOfProduct(data.data)"
                            >
                              <v-icon small>mdi-barcode</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver códigos alternos</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              class="product-action-btn product-action-btn--stock"
                              v-bind="attrs"
                              v-on="on"
                              aria-label="Ver existencia"
                              @click.prevent.stop="showStockByLocation(data.data)"
                            >
                              <v-icon small>mdi-package-variant</v-icon>
                            </v-btn>
                          </template>
                          <span>Ver existencia</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <!-- <template #show-providers="{ data }">
                      <v-btn class="btn-save" @click="showProvidersOfProduct(data.data)">
                        Ver proveedores
                      </v-btn>
                    </template> -->
                  </DxDataGrid>
                </GeneralFilter>
              </v-card>
              <v-dialog v-model="showProviders" max-width="1200">
                <v-card>
                  <v-card-title>
                    Proveedores asociados al producto
                  </v-card-title>
                  <v-card-text>
                    <DxDataGrid :data-source="providers">
                      <DxColumn :width="60" cell-template="show-template" caption=""></DxColumn>
                      <DxColumn data-field="ID_Provider" caption="ID de Proveedor"></DxColumn>
                      <DxColumn data-field="ProviderName" caption="Proveedor"></DxColumn>
                      <template #show-template="{data}">
                          <a href="#" class="mx-1"
                              @click="showProviders = false; $store.dispatch('addWindow',{
                                  name: 'providerData',
                                  component: 'ProviderData',
                                  unique: false,
                                  meta: {provider: data.data}
                              })">
                              <v-icon color="primary">mdi-eye</v-icon>
                          </a>
                      </template>
                    </DxDataGrid>
                  </v-card-text>
                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn class="btncontinue" @click="showProviders = false">
                        Continuar
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="showBarCodes" max-width="600">
                <v-card>
                  <v-card-title>
                    Códigos de barra / Códigos alternos
                  </v-card-title>
                  <v-card-text>
                    <DxDataGrid :data-source="codes">
                      <DxColumn data-field="BarCode" caption="Códigos de barra / código alterno"></DxColumn>
                      <DxColumn :width="70" cell-template="check-principal" caption="Principal"></DxColumn>
                      <template #check-principal="{data}">
                        <div>
                          <center><v-checkbox readonly v-model="data.data.PrincipalBarCode"></v-checkbox></center>
                        </div>
                      </template>
                    </DxDataGrid>
                  </v-card-text>
                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn class="btncontinue" @click="showBarCodes = false">
                        Continuar
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="showLocationStock" max-width="1200">
                <v-card>
                  <v-card-title>
                    Existencia por ubicación
                  </v-card-title>
                  <v-card-subtitle v-if="selectedProductStock">
                    {{ selectedProductStock.ID_Item }} - {{ selectedProductStock.ItemName }}
                  </v-card-subtitle>
                  <v-card-text>
                    <DxDataGrid :data-source="locationStocks" :show-borders="true">
                      <DxColumn data-field="ID_ItemBatch" caption="Lote"></DxColumn>
                      <DxColumn data-field="TotalStock" caption="Disponible"></DxColumn>
                      <DxColumn cell-template="assign-location-stock" caption="Ubicacion selector" :min-width="320"></DxColumn>
                      <DxColumn data-field="WarehouseName" caption="Almacen"></DxColumn>
                      <DxColumn data-field="locationCode" caption="Codigo Ubicacion"></DxColumn>
                      <DxColumn data-field="location" caption="Nombre ubicacion"></DxColumn>
                      <template #assign-location-stock="{ data }">
                        <div class="d-flex align-center" style="gap: 8px; min-width: 300px;">
                          <v-autocomplete
                            :value="data.data.location_id"
                            :items="data.data.availableLocations || []"
                            item-text="location"
                            item-value="ID_location"
                            outlined
                            dense
                            hide-details
                            :loading="data.data.loadingLocations || data.data.applyingLocation"
                            label="Seleccionar ubicación"
                            @focus="prepareStockRowLocations(data.data)"
                            @change="(value) => handleStockRowLocationChange(value, data.data)"
                          ></v-autocomplete>
                          <v-btn
                            class="btn-save"
                            x-small
                            :disabled="!getStockRowWarehouseId(data.data)"
                            @click="openStockLocationManager(getStockRowWarehouseId(data.data), data.data)"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </DxDataGrid>
                  </v-card-text>
                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn class="btncontinue" @click="showLocationStock = false">
                        Continuar
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <WarehouseLocationManagerDialog
                v-model="showStockLocationManager"
                :initial-warehouse-id="stockLocationManagerWarehouseId"
                :selection-mode="true"
                :auto-select-on-create="true"
                @location-selected="handleStockLocationSelected"
                @locations-updated="handleStockLocationsUpdated"
              />
              <ProductPriceListEditorDialog
                v-model="showPriceListEditor"
                :product-id="selectedPriceListProductId"
                @saved="handleProductPriceListSaved"
              />
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-card flat class="pa-1 position-relative">
              <v-card class="pa-4 white component-v-card">
                <v-row class="ma-3">
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="bulkEdit.filter"
                      label="Buscar por código, nombre o código de barra"
                      outlined
                      dense
                      append-icon="mdi-magnify"
                      @keyup.enter="loadBulkEditProducts"
                      @click:append="loadBulkEditProducts"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn 
                      color="primary" 
                      @click="loadBulkEditProducts"
                      :loading="bulkEdit.loading"
                    >
                      <v-icon left>mdi-reload</v-icon>
                      Buscar Productos
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3" v-if="bulkEdit.products.length > 0">
                    <v-btn 
                      color="success" 
                      @click="saveBulkEdit"
                      :loading="bulkEdit.saving"
                      :disabled="!hasChanges"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Guardar Cambios
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="ma-3">
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="bulkEdit.familyFilter"
                      :items="bulkEdit.familyOptions"
                      item-text="name"
                      item-value="value"
                      label="Familia"
                      outlined
                      dense
                      clearable
                      @change="onFamilyChange"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="bulkEdit.categoryFilter"
                      :items="bulkEdit.categoryOptions"
                      item-text="name"
                      item-value="value"
                      label="Categoría"
                      outlined
                      dense
                      clearable
                      @change="onCategoryChange"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="bulkEdit.subcategoryFilter"
                      :items="bulkEdit.subcategoryOptions"
                      item-text="name"
                      item-value="value"
                      label="Subcategoría"
                      outlined
                      dense
                      clearable
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn 
                      color="orange" 
                      @click="clearBulkEditFilters"
                      dark
                    >
                      <v-icon left>mdi-filter-remove</v-icon>
                      Limpiar Filtros
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="ma-3">
                  <v-col cols="12" md="4">
                    <v-checkbox
                      v-model="bulkEdit.showFamilyCategory"
                      label="Mostrar Familia y Categoría en la tabla"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row class="ma-3" v-if="bulkEdit.products.length > 0">
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model.number="bulkEdit.massDiscountPercentage"
                      label="% Desc. Máx (aplicar a todos)"
                      outlined
                      dense
                      suffix="%"
                      type="number"
                      min="0"
                      max="100"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model.number="bulkEdit.massSalePercentage"
                      label="% Venta Máx (aplicar a todos)"
                      outlined
                      dense
                      suffix="%"
                      type="number"
                      min="0"
                      max="100"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn
                      color="primary"
                      @click="applyMassValues"
                      :disabled="!bulkEdit.massDiscountPercentage && !bulkEdit.massSalePercentage"
                      block
                    >
                      <v-icon left>mdi-check-all</v-icon>
                      Aplicar a Todos
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="ma-3" v-if="productsWithHighCost > 0">
                  <v-col cols="12">
                    <v-alert type="error" outlined>
                      <div>
                        <strong>Productos con costo promedio mayor o igual al precio mínimo de venta: <v-btn color="error" @click="sortProductsByPriority()">Errores {{ productsWithHighCost }}</v-btn></strong> 
                      </div>
                    </v-alert>
                  </v-col>
                </v-row>

                <DxDataGrid 
                  ref="bulkEditGrid"
                  :data-source="bulkEdit.products" 
                  key-expr="ID_Item" 
                  :show-row-lines="showRowLines"
                  :show-borders="showBorders" 
                  :row-alternation-enabled="rowAlternationEnabled"
                  :column-auto-width="true"
                  @exporting="onExportingBulkEdit"
                  @cell-prepared="onCellPrepared"
                >
                  <DxExport :enabled="true" />
                  <DxScrolling row-rendering-mode="virtual" />
                  <DxPaging :page-size="20" />
                  <DxEditing 
                    :allow-updating="true" 
                    mode="cell"
                  />
                  <DxColumn data-field="ID_Item" caption="ID Producto" :width="140" :allow-editing="false" alignment="left" css-class="text-left"></DxColumn>
                  <DxColumn data-field="BarCode" caption="Código de Barra" :allow-editing="false" alignment="left" css-class="text-left"></DxColumn>
                  <DxColumn data-field="ItemName" caption="Nombre del Producto" :allow-editing="false" alignment="left" css-class="text-left"></DxColumn>
                  <DxColumn v-if="bulkEdit.showFamilyCategory" data-field="FamilyName" caption="Familia" :allow-editing="false" alignment="right" css-class="text-right"></DxColumn>
                  <DxColumn v-if="bulkEdit.showFamilyCategory" data-field="CategoryName" caption="Categoría" :allow-editing="false" alignment="right" css-class="text-right"></DxColumn>
                  <DxColumn data-field="ItemPrice" caption="Precio" :width="100" :allow-editing="false" alignment="right" css-class="text-right" :customize-text="formatNumber"></DxColumn>
                  <DxColumn data-field="costo_promedio" caption="Costo Promedio" :width="120" :allow-editing="false" alignment="right" css-class="text-right" :customize-text="formatNumber"></DxColumn>
                  <DxColumn 
                    data-field="MaxDiscountPercentage" 
                    caption="% Desc. Máx" 
                    :width="110"
                    data-type="number"
                    cell-template="view-discount-percentage"
                    edit-cell-template="edit-discount-percentage"
                    alignment="right"
                    css-class="text-right-editable"
                  >
                    <DxFormat type="fixedPoint" :precision="2" />
                  </DxColumn>
                  <DxColumn 
                    caption="Precio Mín. Venta" 
                    :width="130"
                    :allow-editing="false"
                    :calculate-cell-value="calculateMinPrice"
                    :customize-text="formatNumber"
                    alignment="right"
                    css-class="text-right"
                  ></DxColumn>
                  <DxColumn 
                    data-field="MaxSalePercentage" 
                    caption="% Venta Máx" 
                    :width="110"
                    data-type="number"
                    cell-template="view-sale-percentage"
                    edit-cell-template="edit-sale-percentage"
                    alignment="right"
                    css-class="text-right-editable"
                  >
                    <DxFormat type="fixedPoint" :precision="2" />
                  </DxColumn>
                  <DxColumn 
                    caption="Precio Máx. Venta" 
                    :width="130"
                    :allow-editing="false"
                    :calculate-cell-value="calculateMaxPrice"
                    :customize-text="formatNumber"
                    alignment="right"
                    css-class="text-right"
                  ></DxColumn>
                  <DxColumn 
                    :width="70" 
                    caption="Estado" 
                    cell-template="status-template"
                    :allow-editing="false"
                    alignment="center"
                  ></DxColumn>

                  <template #view-discount-percentage="{ data }">
                    <div class="editable-cell-view">
                      <v-icon small class="edit-icon">mdi-pencil</v-icon>
                      <span class="cell-value">{{ data.data.MaxDiscountPercentage.toFixed(2) }}%</span>
                    </div>
                  </template>

                  <template #edit-discount-percentage="{ data }">
                    <div>
                      <v-text-field
                        v-model.number="data.data.MaxDiscountPercentage"
                        @blur="updateDiscountPercentage(data.data, data.data.MaxDiscountPercentage)"
                        @keydown="handleKeydown($event, data.data, 'MaxDiscountPercentage')"
                        dense
                        hide-details
                        suffix="%"
                        class="editable-field"
                        min="0"
                        max="100"
                        autofocus
                      ></v-text-field>
                    </div>
                  </template>

                  <template #view-sale-percentage="{ data }">
                    <div class="editable-cell-view">
                      <v-icon small class="edit-icon">mdi-pencil</v-icon>
                      <span class="cell-value">{{ data.data.MaxSalePercentage.toFixed(2) }}%</span>
                    </div>
                  </template>

                  <template #edit-sale-percentage="{ data }">
                    <div>
                      <v-text-field
                        v-model.number="data.data.MaxSalePercentage"
                        @blur="updateSalePercentage(data.data, data.data.MaxSalePercentage)"
                        @keydown="handleKeydown($event, data.data, 'MaxSalePercentage')"
                        dense
                        hide-details
                        suffix="%"
                        class="editable-field"
                        min="0"
                        max="100"
                        autofocus
                      ></v-text-field>
                    </div>
                  </template>

                  <template #status-template="{ data }">
                    <div class="text-center">
                      <v-tooltip bottom v-if="bulkEdit.updatedProducts.includes(data.data.ID_Item)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon 
                            color="success" 
                            v-bind="attrs" 
                            v-on="on"
                            size="24"
                          >
                            mdi-check-circle
                          </v-icon>
                        </template>
                        <span>Actualizado</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else-if="bulkEdit.modifiedProducts.includes(data.data.ID_Item)">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon 
                            color="orange" 
                            v-bind="attrs" 
                            v-on="on"
                            size="24"
                          >
                            mdi-pencil-circle
                          </v-icon>
                        </template>
                        <span>Modificado (pendiente)</span>
                      </v-tooltip>
                      <v-tooltip bottom v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon 
                            color="grey" 
                            v-bind="attrs" 
                            v-on="on"
                            size="24"
                          >
                            mdi-minus-circle-outline
                          </v-icon>
                        </template>
                        <span>Sin cambios</span>
                      </v-tooltip>
                    </div>
                  </template>
                </DxDataGrid>

                <v-row class="ma-3" v-if="bulkEdit.modifiedProducts.length > 0 || bulkEdit.updatedProducts.length > 0">
                  <v-col cols="12">
                    <v-alert type="info" outlined>
                      <div>
                        <strong v-if="bulkEdit.modifiedProducts.length > 0">Productos modificados (pendientes): {{ bulkEdit.modifiedProducts.length }}</strong>
                        <strong v-if="bulkEdit.updatedProducts.length > 0" class="ml-4">Productos actualizados: {{ bulkEdit.updatedProducts.length }}</strong>
                      </div>
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <LocationEdition />
          </v-tab-item>
          <v-tab-item value="tab-4">
            <PriceEdition />
          </v-tab-item>
          <v-tab-item v-if="showExternalProductImagesLoadTab" value="tab-5">
            <ManageExternalProductImagesLoad
              :key="externalProductImagesLoadKey"
              :can-manage-images="externalProductImagesAccess.canManageImages"
            />
          </v-tab-item>
          <v-tab-item v-if="showExternalProductImagesHistoryTab" value="tab-6">
            <ManageExternalProductImagesHistory
              :key="externalProductImagesHistoryKey"
              :can-manage-images="externalProductImagesAccess.canManageImages"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>
    
    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
    
    <!--product-data v-if="showProduct"
                              :key="showProduct.data.ID_Item"
                              @reloadData="reloadProducts"
                              :product="showProduct.data"
                              :win="win"
                  ></product-data-->

  </v-expansion-panel>
</template>

<script>

import DatePicker from "../../../components/DatePicker";
import { DxDataGrid, DxColumn, DxScrolling, DxPaging, DxExport, DxEditing, DxFormat } from 'devextreme-vue/data-grid';
import { mapGetters, mapState } from "vuex";
import GeneralFilter from  "@/components/GeneralFilter";
import Alerts from "@/components/Alerts";
import LocationEdition from "../tabs/LocationEdition.vue";
import PriceEdition from "../tabs/PriceEdition.vue";
import WarehouseLocationManagerDialog from "@/components/inventory/WarehouseLocationManagerDialog.vue";
import ProductPriceListEditorDialog from "@/components/inventory/ProductPriceListEditorDialog.vue";
import ManageExternalProductImagesLoad from "@/views/settings/business/partial/ManageExternalProductImagesLoad.vue";
import ManageExternalProductImagesHistory from "@/views/settings/business/partial/ManageExternalProductImagesHistory.vue";

import { printToExcel } from "@/helpers/printToexcel";
//import ProductData from "@/views/inventory/mainPages/ManageProduct";
export default {
  name: "ProductsList",
  components: { DatePicker, DxDataGrid, DxColumn, DxScrolling, DxPaging, DxExport, DxEditing, DxFormat, GeneralFilter, Alerts, LocationEdition, PriceEdition, WarehouseLocationManagerDialog, ProductPriceListEditorDialog, ManageExternalProductImagesLoad, ManageExternalProductImagesHistory },
  props: ['win'],
  data() {
    return {
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      loading: false,
      tab: null,
      externalProductImagesAccess: {
        enabled: false,
        canManageCredentials: false,
        canManageImages: false,
        canViewHistory: false
      },
      externalProductImagesLoadKey: 0,
      externalProductImagesHistoryKey: 0,
      panel: 0,
      form: {},
      showFilter: false,
      products: [],
      showProduct: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      search: {},
      AllData: [],
      filterWarehouses: {},
      filterParams: {
        warehouse: [{ name: 'Todos', value: 'Todos' }],
        family: [{ name: 'Todos', value: 'Todos' }],
      },
      warehouses: {},
      families: {},
      categories: {},
      subcategories: {},
      brands: {},
      providers: [],
      codes: [],
      locationStocks: [],
      showProviders: false,
      showBarCodes: false,
      showLocationStock: false,
      showPriceListEditor: false,
      selectedPriceListProductId: null,
      selectedProductStock: null,
      stockWarehouseLocationsCache: {},
      showStockLocationManager: false,
      stockLocationManagerWarehouseId: null,
      stockLocationManagerRowKey: null,
      query: {
        filter: null
      },
      SpecialInventoryReport: JSON.parse(localStorage.getItem('user')).SpecialInventoryReport,
      barcodeExist: false,
      filterColumns: [
        {
            name: "column_Warehouse",
            title: 'Almacen',
            value: '',
            type: 'select',
            options: []
        },
        {
            name: "equals_family",
            title: 'Familia',
            value: '',
            type: 'select',
            options: []
        },
        {
            name: "equals_category",
            title: 'Categoría',
            value: '',
            type: 'select',
            options: []
        },
        {
            name: "equals_subcategory",
            title: 'Subcategoría',
            value: '',
            type: 'select',
            options: []
        },
        {
            name: "equals_items_brand",
            title: 'Marca',
            value: '',
            type: 'select',
            options: []
        },
        {
            name: "equals_location_id",
            title: 'Ubicaci\u00f3n',
            value: '',
            type: 'dynamic-select',
            options: [],
            supplierColumnIndex: 0,
            disabledMessage: 'Seleccione un almac\u00e9n para cargar sus ubicaciones.',
            enabledMessage: 'Mostrando ubicaciones del almac\u00e9n seleccionado.'
        },
      ],
      oldFilterColumnsState: [],
      warehouseLocationsCache: {},
      bulkEdit: {
        filter: '',
        loading: false,
        saving: false,
        products: [],
        modifiedProducts: [],
        updatedProducts: [],
        originalData: {},
        familyFilter: '',
        categoryFilter: '',
        subcategoryFilter: '',
        familyOptions: [],
        categoryOptions: [],
        subcategoryOptions: [],
        showFamilyCategory: false,
        massDiscountPercentage: null,
        massSalePercentage: null,
        blockAutoSave: false
      },
      debounceTimers: {}
    }
  },
  computed: {
    ...mapState(["CurrentBranch"]),
    ...mapGetters(['reloadData']),
    ...mapState(
      "rolesUser",
      {
        rolesStatus: (state) => state.roles,
      }),
    hasChanges() {
      return this.bulkEdit.modifiedProducts.length > 0;
    },
    productsWithHighCost() {
      return this.bulkEdit.products.filter(product => {
        const costoPromedio = product.costo_promedio || 0;
        const precioMinVenta = this.calculateMinPrice(product);
        return costoPromedio >= precioMinVenta;
      }).length;
    },
    showExternalProductImagesLoadTab() {
      return this.externalProductImagesAccess.enabled && this.externalProductImagesAccess.canManageImages;
    },
    showExternalProductImagesHistoryTab() {
      return this.externalProductImagesAccess.enabled && this.externalProductImagesAccess.canViewHistory;
    }
  },
  watch: {
    'reloadData': {
      immediate: true,
      handler: 'reloadProducts2'
    },
    filterColumns: {
      handler(newVal) {
        // console.log('filterColumns ha cambiado.');
        newVal.forEach((newItem, index) => {
          const oldItem = this.oldFilterColumnsState[index];
          if (oldItem && newItem.value !== oldItem.value && index === 0) {
            this.handleWarehouseFilterColumnChange(newItem.value);
          }
          if (oldItem && newItem.value !== oldItem.value && index === 1) {
            this.filterColumns[2].options = this.categories.filter(category => category.id_family == newItem.value).map(category => ({name: category.name, value: category.id}));
          }
          if (oldItem && newItem.value !== oldItem.value && index === 2) {
            // console.log('newItem', newItem);
            this.filterColumns[3].options = this.subcategories.filter(subcategory => subcategory.id_cat == newItem.value).map(subcategory => ({name: subcategory.name, value: subcategory.id}));
          }
        });

        this.oldFilterColumnsState = JSON.parse(JSON.stringify(newVal));
      },
      deep: true // Importante: para detectar cambios dentro de los objetos del array
    }    
  },
  created() {
    this.oldFilterColumnsState = JSON.parse(JSON.stringify(this.filterColumns));
  },

  mounted() {
    this.$store.dispatch('rolesUser/getAllRoles')
    //this.search.BranchName = JSON.parse(localStorage.getItem("user")) || ""
    this.search.business = JSON.parse(localStorage.getItem("user")).businessid || ""
    this.search.branch = JSON.parse(localStorage.getItem("user")).branch || ""
    // this.search.filter = '';
    this.getFamilies()
    this.getCategories()
    this.getSubs()
    this.getBrands()
    this.getWarehouse();
    this.getAllProducts();
    this.Currency = JSON.parse(localStorage.getItem('branch')).Currency;
    this.loadExternalProductImagesAccess();
  },

  methods: {
    async loadExternalProductImagesAccess() {
      try {
        const response = await this.$API.externalProductImages.getAccess();
        this.externalProductImagesAccess = response.data || this.externalProductImagesAccess;
        if (!this.showExternalProductImagesLoadTab && this.tab === 'tab-5') {
          this.tab = 'tab-1';
        }
        if (!this.showExternalProductImagesHistoryTab && this.tab === 'tab-6') {
          this.tab = 'tab-1';
        }
      } catch (error) {
        this.externalProductImagesAccess = {
          enabled: false,
          canManageCredentials: false,
          canManageImages: false,
          canViewHistory: false
        };
        if (this.tab === 'tab-5' || this.tab === 'tab-6') {
          this.tab = 'tab-1';
        }
      }
    },
    sortProductsByPriority() {
      this.bulkEdit.products.sort((a, b) => {
        const aHighCost = (a.costo_promedio || 0) >= this.calculateMinPrice(a);
        const bHighCost = (b.costo_promedio || 0) >= this.calculateMinPrice(b);
        if (aHighCost && !bHighCost) return -1;
        if (!aHighCost && bHighCost) return 1;
        return 0;
      });
    },
    onExporting(e) {
      printToExcel(e, 'Productos')
    },
    reload() {
      this.getAllProducts()
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop)
        //alert(this.$store.getters.getScrollTop)
      }, 300);
    },
    getFamilies() {
      this.$API.itemtypes.getFamilies().then(response => {
        this.families = response;
        this.filterColumns[1].options = this.families.map(family => ({name: family.name, value: family.id}));
        
        // Inicializar opciones de familia para edición masiva
        this.bulkEdit.familyOptions = this.families.map(family => ({
          name: family.name,
          value: family.id
        }));

        // console.log("response famili", response);
      })
    },
    getCategories() {
      this.$API.itemtypes.getCategories()
        .then(response => {
          this.categories = response;
          // this.filterColumns[2].options = this.categories.map(category => ({name: category.name, value: category.id}));
        })
    },
    getBrands() {
      this.$API.itemtypes.getBrands().then(response => {
        this.brands = response;
        this.filterColumns[4].options = this.brands.map(brand => ({name: brand.brand, value: brand.id}));
      })
    },
    getSubs() {
      this.$API.itemtypes.getSubs()
        .then(response => {
          this.subcategories = response;
          // this.filterColumns[3].options = this.subcategories.map(subcategory => ({name: subcategory.name, value: subcategory.id}));
        })
    },
    getWarehouse() {
      let idbusiness = JSON.parse(localStorage.getItem("user")).businessid || ""
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || ""
      this.filterWarehouses.branch = idbranch
      this.filterWarehouses.business = idbusiness
      this.$API.warehouse.getWarehouses(this.filterWarehouses)
        .then(response => {
          this.warehouses = response
        })
    },
    async handleWarehouseFilterColumnChange(warehouseId) {
      this.filterColumns[5].value = '';
      this.filterColumns[5].options = [];

      if (!warehouseId || warehouseId === 'Todos') {
        return;
      }

      const cacheKey = String(warehouseId);
      let locations = this.warehouseLocationsCache[cacheKey];

      if (!locations) {
        const response = await this.$API.inventoryWarehouseLocations.getByWarehouse({ warehouseId });
        locations = (response || []).map((location) => ({
          id: cacheKey,
          option: {
            name: `${location.LocationCode ? `${location.LocationCode} - ` : ''}${location.LocationName}`,
            value: location.ID_Location
          }
        }));
        this.$set(this.warehouseLocationsCache, cacheKey, locations);
      }

      this.filterColumns[5].options = locations;
    },
    getAllProducts() {
      this.loading = true;
      // console.log('this.search', this.search);
      // console.log('this.filterColumns', this.filterColumns);
      const filterColumns = Object.fromEntries(this.filterColumns.map(item => ([[item.name], item.value])))
      // console.log('filterColumns', filterColumns);

        this.$API.products.filterProductSpecialInventoryWithWareHouseAndProviders({...this.search, ...filterColumns})
          .then(response => {
            // console.log(response);
            this.products = response
            this.AllData = response
  
            this.AllData.forEach(element => {
              if (!this.filterParams.warehouse.some(w => w.value === element.Warehouse)) {
                this.warehouses.forEach(warehouse => {
                  // if (warehouse.ID_Warehouse == element.Warehouse) {
                    this.filterParams.warehouse.push({ name: warehouse.Warehouse, value: warehouse.ID_Warehouse })
                  // }
                });
                this.filterColumns[0].options = this.filterParams.warehouse;
              }
            });
          }).finally(() => {
            this.setProductsCurrency();
            this.checkIfBarCodeSearch();
            this.loading = false;
          })
    },
    setProductsCurrency(){
      if(this.products.length > 0){
        this.products.map((product) => {
          product.ItemPriceFormatted = product.ItemPrice ? `${this.Currency} ${parseFloat(product.ItemPrice).toFixed(2)}`:`${this.Currency} 0.00`
          product.SuggestedPriceFormatted = product.Suggested_price? `${this.Currency} ${parseFloat(product.Suggested_price).toFixed(2)}` : `${this.Currency} 0.00`
        })
      }
    },
    checkIfBarCodeSearch() {
      this.barcodeExist = false;

      if (this.products.length > 0) {
        for (const product of this.products) {
          if (product.BarCode) {
            this.barcodeExist = true;
            break;
          }
        }
      }
    },
    reloadProducts(payload) {
      if (payload) {
        this.showProduct = false;
        this.panel = 0;
      }
      this.getAllProducts()
    },
    async reloadProducts2() {
      if (this.reloadData == 'products') {
        await this.getAllProducts();
        this.$store.dispatch('reloadData', null)
      }
    },
    showProvidersOfProduct(data) {
      this.providers = []
      this.$API.providers.getCheckedProvidersOfProduct({"iditem": data.ID_Item}).then(response => {
        this.providers = response
        this.showProviders = true;
      })
    },
    showCodesOfProduct(data) {
      this.codes = []
      this.$API.inventoryitemsbarcodes.getBarCodesByProduct({ ID_Item: data.ID_Item}).then(response => {
        this.codes = response
        this.showBarCodes = true;
      })
    },
    openPriceListEditor(data) {
      this.selectedPriceListProductId = data.ID_Item;
      this.showPriceListEditor = true;
    },
    handleProductPriceListSaved() {
      this.showAlert("success", "Éxito", "La lista de precios del producto fue actualizada.");
    },
    async showStockByLocation(data) {
      this.locationStocks = []
      this.selectedProductStock = data
      const response = await this.$API.inventoryReports.getInventoryLocationsByProduct({
        ID_Item: data.ID_Item,
        warehouse: data.Warehouse || ''
      })

      this.locationStocks = this.prepareLocationStocks(response || [])
      this.showLocationStock = true;
      this.hydrateStockRowsLocations()
    },
    normalizeStockLocation(location) {
      return {
        ...location,
        ID_location: Number(location.ID_location || location.ID_Location),
        location: location.location || location.LocationName,
        locationCode: location.locationCode || location.LocationCode || "",
      };
    },
    getStockRowWarehouseId(row) {
      return row.Warehouse || row.ID_Warehouse || null;
    },
    prepareLocationStocks(items = []) {
      return items.map((item, index) => {
        const warehouseId = this.getStockRowWarehouseId(item);
        const cachedLocations = warehouseId
          ? this.stockWarehouseLocationsCache[String(warehouseId)] || []
          : [];

        return {
          ...item,
          location: item.location || "",
          locationCode: item.locationCode || "",
          rowKey: [
            item.ID_Inventory || index,
            item.ID_Item || index,
            warehouseId || "warehouse",
            item.ID_ItemBatch || "batch",
          ].join("-"),
          availableLocations: cachedLocations,
          loadingLocations: false,
          applyingLocation: false,
        };
      });
    },
    async hydrateStockRowsLocations(rows = this.locationStocks) {
      const warehouseIds = [...new Set(
        (rows || [])
          .map((row) => this.getStockRowWarehouseId(row))
          .filter((warehouseId) => warehouseId !== null && warehouseId !== undefined && warehouseId !== "")
          .map((warehouseId) => String(warehouseId))
      )];

      if (!warehouseIds.length) {
        return;
      }

      await Promise.all(
        warehouseIds.map((warehouseId) => this.getStockLocationsForWarehouse(warehouseId))
      );
    },
    async getStockLocationsForWarehouse(warehouseId, force = false) {
      if (!warehouseId) {
        return [];
      }

      const key = String(warehouseId);

      if (!force && this.stockWarehouseLocationsCache[key]) {
        return this.stockWarehouseLocationsCache[key];
      }

      const response = await this.$API.inventoryWarehouseLocations.getByWarehouse({ warehouseId });
      const normalized = (response || []).map((location) => this.normalizeStockLocation(location));
      this.$set(this.stockWarehouseLocationsCache, key, normalized);

      this.locationStocks.forEach((item) => {
        if (String(this.getStockRowWarehouseId(item)) === key) {
          item.availableLocations = normalized;
        }
      });

      return normalized;
    },
    async prepareStockRowLocations(row) {
      const warehouseId = this.getStockRowWarehouseId(row);

      if (!warehouseId || row.loadingLocations) {
        return;
      }

      row.loadingLocations = true;

      try {
        row.availableLocations = await this.getStockLocationsForWarehouse(warehouseId);
      } finally {
        row.loadingLocations = false;
      }
    },
    async assignStockLocations(assignments) {
      if (!assignments.length) {
        return;
      }

      const user = JSON.parse(localStorage.getItem("user")) || {};
      await this.$API.inventoryWarehouseLocations.assign({
        assignments,
        user: user.id,
      });
    },
    async handleStockRowLocationChange(locationId, row) {
      if (!locationId || String(locationId) === String(row.location_id)) {
        return;
      }

      row.applyingLocation = true;

      try {
        await this.prepareStockRowLocations(row);
        await this.assignStockLocations([{ inventoryId: row.ID_Inventory, locationId }]);

        const location = (row.availableLocations || []).find(
          (current) => String(current.ID_location) === String(locationId)
        );

        row.location_id = locationId;
        row.location = location ? location.location : row.location;
        row.locationCode = location ? location.locationCode : row.locationCode;
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Ubicaciones", error || "No se pudo asignar la ubicación.");
      } finally {
        row.applyingLocation = false;
      }
    },
    openStockLocationManager(warehouseId, row) {
      this.stockLocationManagerWarehouseId = warehouseId;
      this.stockLocationManagerRowKey = row ? row.rowKey : null;
      this.showStockLocationManager = true;
    },
    async handleStockLocationSelected(location) {
      const normalized = this.normalizeStockLocation(location);
      const warehouseId = this.stockLocationManagerWarehouseId;

      await this.getStockLocationsForWarehouse(warehouseId, true);

      const row = this.locationStocks.find((item) => item.rowKey === this.stockLocationManagerRowKey);
      if (row) {
        row.availableLocations = await this.getStockLocationsForWarehouse(this.getStockRowWarehouseId(row));
        await this.handleStockRowLocationChange(normalized.ID_location, row);
      }
    },
    async handleStockLocationsUpdated(payload = {}) {
      const warehouseId = payload.warehouseId || this.stockLocationManagerWarehouseId;

      if (warehouseId) {
        await this.getStockLocationsForWarehouse(warehouseId, true);
      }

      if (this.selectedProductStock) {
        const response = await this.$API.inventoryReports.getInventoryLocationsByProduct({
          ID_Item: this.selectedProductStock.ID_Item,
          warehouse: this.selectedProductStock.Warehouse || "",
        });
        this.locationStocks = this.prepareLocationStocks(response || []);
      }
    },
    filterHandler(response) {
      this.products = response
    },
    filterHandlerSpecialInventory(response) {
      // console.log(`filterHandlerSpecialInventory`);
      this.products = response
      this.setProductsCurrency()
      this.checkIfBarCodeSearch()
    },
    loadBulkEditProducts() {
      // Desbloquear auto-guardado al buscar productos nuevamente
      this.bulkEdit.blockAutoSave = false;
      
      this.bulkEdit.loading = true;
      this.bulkEdit.modifiedProducts = [];
      this.bulkEdit.updatedProducts = [];
      this.bulkEdit.originalData = {};
      
      const params = {
        filter: this.bulkEdit.filter || '',
        family: this.bulkEdit.familyFilter || '',
        category: this.bulkEdit.categoryFilter || '',
        subcategory: this.bulkEdit.subcategoryFilter || ''
      };
      
      this.$API.products.getProductsForBulkEdit(params)
        .then(response => {
          this.bulkEdit.products = response.map(product => ({
            ...product,
            MaxDiscountPercentage: parseFloat(product.MaxDiscountPercentage) || 0,
            MaxDiscountDecimal: parseFloat(product.MaxDiscountDecimal) || 0,
            MaxSalePercentage: parseFloat(product.MaxSalePercentage) || 0,
            MaxSaleDecimal: parseFloat(product.MaxSaleDecimal) || 0,
            ItemPrice: parseFloat(product.ItemPrice) || 0,
            costo_promedio: parseFloat(product.costo_promedio) || 0
          }));
          
          // Guardar datos originales
          this.bulkEdit.products.forEach(product => {
            this.bulkEdit.originalData[product.ID_Item] = {
              MaxDiscountPercentage: product.MaxDiscountPercentage,
              MaxDiscountDecimal: product.MaxDiscountDecimal,
              MaxSalePercentage: product.MaxSalePercentage,
              MaxSaleDecimal: product.MaxSaleDecimal
            };
          });
        })
        .catch(error => {
          console.error('Error al cargar productos para edición masiva:', error);
          this.showAlert('danger', 'Error', 'No se pudieron cargar los productos');
        })
        .finally(() => {
          this.bulkEdit.loading = false;
        });
    },
    test(){
      console.log('test');
    },
    updateDiscountPercentage(product, value) {
      // Si está bloqueado el auto-guardado, no procesar
      if (this.bulkEdit.blockAutoSave) return;
      
      let percentage = parseFloat(value) || 0;
      // Validar rango 0-100
      if (percentage < 0) percentage = 0;
      if (percentage > 100) percentage = 100;
      
      product.MaxDiscountPercentage = percentage;
      product.MaxDiscountDecimal = (percentage / 100);
      
      // Usar debounce para evitar múltiples llamadas
      const timerId = `discount_${product.ID_Item}`;
      if (this.debounceTimers[timerId]) {
        clearTimeout(this.debounceTimers[timerId]);
      }
      this.debounceTimers[timerId] = setTimeout(() => {
        this.markAsModified(product);
        delete this.debounceTimers[timerId];
      }, 500);
    },
    
    updateSalePercentage(product, value) {
      // Si está bloqueado el auto-guardado, no procesar
      if (this.bulkEdit.blockAutoSave) return;
      
      let percentage = parseFloat(value) || 0;
      // Validar rango 0-100
      if (percentage < 0) percentage = 0;
      if (percentage > 100) percentage = 100;
      
      product.MaxSalePercentage = percentage;
      product.MaxSaleDecimal = (percentage / 100);
      
      // Usar debounce para evitar múltiples llamadas
      const timerId = `sale_${product.ID_Item}`;
      if (this.debounceTimers[timerId]) {
        clearTimeout(this.debounceTimers[timerId]);
      }
      this.debounceTimers[timerId] = setTimeout(() => {
        this.markAsModified(product);
        delete this.debounceTimers[timerId];
      }, 500);
    },
    
    handleKeydown(event, product, field) {
      // Manejar Tab y Enter para actualizar el valor
      if (event.key === 'Tab' || event.key === 'Enter') {
        // Forzar la actualización del campo antes de cambiar de celda
        const currentValue = parseFloat(product[field]) || 0;
        if (field === 'MaxDiscountPercentage') {
          this.updateDiscountPercentage(product, currentValue);
        } else if (field === 'MaxSalePercentage') {
          this.updateSalePercentage(product, currentValue);
        }
      }
      
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        
        let currentValue = parseFloat(product[field]) || 0;
        let newValue = currentValue;
        
        if (event.key === 'ArrowUp') {
          newValue = Math.min(100, currentValue + 1);
        } else if (event.key === 'ArrowDown') {
          newValue = Math.max(0, currentValue - 1);
        }
        
        product[field] = newValue;
        
        if (field === 'MaxDiscountPercentage') {
          product.MaxDiscountDecimal = newValue / 100;
        } else if (field === 'MaxSalePercentage') {
          product.MaxSaleDecimal = newValue / 100;
        }
        
        // Forzar actualización de la UI
        this.$forceUpdate();
      }
    },
    
    calculateDiscountDecimal(rowData) {
      return (parseFloat(rowData.MaxDiscountPercentage || 0) / 100);
    },
    
    calculateSaleDecimal(rowData) {
      return (parseFloat(rowData.MaxSalePercentage || 0) / 100);
    },
    
    calculateMinPrice(rowData) {
      // Precio mínimo de venta = Precio - (Precio * Porcentaje de Descuento / 100)
      const price = parseFloat(rowData.ItemPrice || 0);
      const discountPercentage = parseFloat(rowData.MaxDiscountPercentage || 0);
      const discountAmount = (price * discountPercentage) / 100;
      return price - discountAmount;
    },
    
    calculateMaxPrice(rowData) {
      // Precio máximo de venta = Precio + (Precio * Porcentaje de Venta / 100)
      const price = parseFloat(rowData.ItemPrice || 0);
      const salePercentage = parseFloat(rowData.MaxSalePercentage || 0);
      const markupAmount = (price * salePercentage) / 100;
      return price + markupAmount;
    },
    
    markAsModified(product, skipAutoSave = false) {
      const original = this.bulkEdit.originalData[product.ID_Item];
      
      if (original) {
        // Convertir a números para comparar correctamente
        const originalDiscount = parseFloat(original.MaxDiscountPercentage) || 0;
        const currentDiscount = parseFloat(product.MaxDiscountPercentage) || 0;
        const originalSale = parseFloat(original.MaxSalePercentage) || 0;
        const currentSale = parseFloat(product.MaxSalePercentage) || 0;
        
        const hasChanges = 
          originalDiscount !== currentDiscount ||
          originalSale !== currentSale;
        
        if (hasChanges) {
          // Agregar a modificados si no existe
          if (!this.bulkEdit.modifiedProducts.includes(product.ID_Item)) {
            this.bulkEdit.modifiedProducts.push(product.ID_Item);
          }

          // Actualizar automáticamente solo si no se especifica skipAutoSave Y no está bloqueado globalmente
          if (!skipAutoSave && !this.bulkEdit.blockAutoSave) {
            const discountChanged = originalDiscount !== currentDiscount;
            const saleChanged = originalSale !== currentSale;
            const atLeastOneModified = discountChanged || saleChanged;
            const bothGreaterThanZero = currentDiscount > 0 && currentSale > 0;
            
            if (atLeastOneModified && bothGreaterThanZero) {
              this.updateProductInDatabase(product);
            }
          }
        } else {
          // Remover de modificados si existe
          const index = this.bulkEdit.modifiedProducts.indexOf(product.ID_Item);
          if (index > -1) {
            this.bulkEdit.modifiedProducts.splice(index, 1);
          }
        }
      }
    },
    
    updateProductInDatabase(product) {
      // Actualizar producto individual en el backend
      const productData = {
        products: [{
          ID_Item: product.ID_Item,
          MaxDiscountPercentage: parseFloat(product.MaxDiscountPercentage) || 0,
          MaxDiscountDecimal: parseFloat(product.MaxDiscountDecimal) || 0,
          MaxSalePercentage: parseFloat(product.MaxSalePercentage) || 0,
          MaxSaleDecimal: parseFloat(product.MaxSaleDecimal) || 0
        }]
      };
      
      this.$API.products.updateProductsBulk(productData)
        .then(() => {
          // Actualizar datos originales después de guardar exitosamente
          this.bulkEdit.originalData[product.ID_Item] = {
            MaxDiscountPercentage: product.MaxDiscountPercentage,
            MaxDiscountDecimal: product.MaxDiscountDecimal,
            MaxSalePercentage: product.MaxSalePercentage,
            MaxSaleDecimal: product.MaxSaleDecimal
          };
          
          // Remover de la lista de modificados y agregar a actualizados
          const modIndex = this.bulkEdit.modifiedProducts.indexOf(product.ID_Item);
          if (modIndex > -1) {
            this.bulkEdit.modifiedProducts.splice(modIndex, 1);
          }
          if (!this.bulkEdit.updatedProducts.includes(product.ID_Item)) {
            this.bulkEdit.updatedProducts.push(product.ID_Item);
          }
          
          // Forzar actualización de la UI
          this.$forceUpdate();
        })
        .catch(error => {
          console.error('Error al actualizar producto:', error);
          this.showAlert('danger', 'Error', `No se pudo actualizar el producto ${product.ID_Item}`);
        });
    },
    
    onCellPrepared(e) {
      if (e.rowType === 'data') {
        // Sombrear toda la fila de rojo claro si costo_promedio >= ItemPrice (precio mínimo de venta)
        const costoPromedio = e.data.costo_promedio || 0;
        const precioMinVenta = this.calculateMinPrice(e.data);
        
        if (costoPromedio >= precioMinVenta) {
          e.cellElement.style.backgroundColor = '#ffcccc';
          return; // Priorizar el sombreado rojo sobre otros colores
        }
        
        // Sombreado amarillo para campos modificados
        if (e.column.dataField) {
          const isModified = this.bulkEdit.modifiedProducts.includes(e.data.ID_Item);
          if (isModified && (
            e.column.dataField === 'MaxDiscountPercentage' || 
            e.column.dataField === 'MaxDiscountDecimal' ||
            e.column.dataField === 'MaxSalePercentage' ||
            e.column.dataField === 'MaxSaleDecimal'
          )) {
            e.cellElement.style.backgroundColor = '#fff3cd';
          }
        }
      }
    },
    
    saveBulkEdit() {
      if (!this.hasChanges) {
        this.showAlert('info', 'Información', 'No hay cambios para guardar');
        return;
      }

      // Desbloquear auto-guardado al hacer guardado manual
      this.bulkEdit.blockAutoSave = false;

      this.bulkEdit.saving = true;
      
      const modifiedProducts = this.bulkEdit.products
        .filter(product => this.bulkEdit.modifiedProducts.includes(product.ID_Item))
        .map(product => ({
          ID_Item: product.ID_Item,
          MaxDiscountPercentage: parseFloat(product.MaxDiscountPercentage) || 0,
          MaxDiscountDecimal: parseFloat(product.MaxDiscountDecimal) || 0,
          MaxSalePercentage: parseFloat(product.MaxSalePercentage) || 0,
          MaxSaleDecimal: parseFloat(product.MaxSaleDecimal) || 0
        }));

      this.$API.products.updateProductsBulk({ products: modifiedProducts })
        .then(response => {
          this.showAlert('success', 'Éxito', response.message || 'Productos actualizados correctamente');
          
          // Actualizar datos originales
          modifiedProducts.forEach(product => {
            this.bulkEdit.originalData[product.ID_Item] = {
              MaxDiscountPercentage: product.MaxDiscountPercentage,
              MaxDiscountDecimal: product.MaxDiscountDecimal,
              MaxSalePercentage: product.MaxSalePercentage,
              MaxSaleDecimal: product.MaxSaleDecimal
            };
            
            // Mover de modificados a actualizados
            if (!this.bulkEdit.updatedProducts.includes(product.ID_Item)) {
              this.bulkEdit.updatedProducts.push(product.ID_Item);
            }
          });
          
          // Limpiar lista de modificados
          this.bulkEdit.modifiedProducts = [];
          this.$forceUpdate();
        })
        .catch(error => {
          console.error('Error al guardar cambios:', error);
          this.showAlert('danger', 'Error', 'No se pudieron guardar los cambios');
        })
        .finally(() => {
          this.bulkEdit.saving = false;
        });
    },
    
    onExportingBulkEdit(e) {
      printToExcel(e, 'Productos_Edicion_Masiva')
    },

    formatNumber(cellInfo) {
      if (cellInfo.value == null || cellInfo.value === '') return '';
      const value = parseFloat(cellInfo.value);
      if (isNaN(value)) return '';
      
      // Formato: $#,###.##
      const formatted = value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return `$${formatted}`;
    },

    applyMassValues() {
      if (this.bulkEdit.products.length === 0) {
        this.showAlert('info', 'Información', 'No hay productos cargados');
        return;
      }

      const discountValue = parseFloat(this.bulkEdit.massDiscountPercentage);
      const saleValue = parseFloat(this.bulkEdit.massSalePercentage);

      if (isNaN(discountValue) && isNaN(saleValue)) {
        this.showAlert('warning', 'Advertencia', 'Debe ingresar al menos un valor');
        return;
      }

      // Activar bandera para bloquear auto-guardado
      this.bulkEdit.blockAutoSave = true;

      // Limpiar todos los timers de debounce pendientes para evitar auto-guardados
      Object.keys(this.debounceTimers).forEach(timerId => {
        clearTimeout(this.debounceTimers[timerId]);
        delete this.debounceTimers[timerId];
      });

      // Aplicar valores a todos los productos sin llamar a markAsModified
      this.bulkEdit.products.forEach(product => {
        const original = this.bulkEdit.originalData[product.ID_Item];
        
        if (!isNaN(discountValue) && discountValue >= 0 && discountValue <= 100) {
          product.MaxDiscountPercentage = discountValue;
          product.MaxDiscountDecimal = discountValue / 100;
        }
        
        if (!isNaN(saleValue) && saleValue >= 0 && saleValue <= 100) {
          product.MaxSalePercentage = saleValue;
          product.MaxSaleDecimal = saleValue / 100;
        }

        // Verificar si hay cambios comparando con el original
        if (original) {
          const originalDiscount = parseFloat(original.MaxDiscountPercentage) || 0;
          const currentDiscount = parseFloat(product.MaxDiscountPercentage) || 0;
          const originalSale = parseFloat(original.MaxSalePercentage) || 0;
          const currentSale = parseFloat(product.MaxSalePercentage) || 0;
          
          const hasChanges = originalDiscount !== currentDiscount || originalSale !== currentSale;
          
          // Agregar a modificados solo si hay cambios y no está ya en la lista
          if (hasChanges && !this.bulkEdit.modifiedProducts.includes(product.ID_Item)) {
            this.bulkEdit.modifiedProducts.push(product.ID_Item);
          }
        }
      });

      // NO desbloquear blockAutoSave aquí - permanecerá bloqueado hasta que se guarde o se busque de nuevo

      // Forzar actualización de la UI
      this.$forceUpdate();

      // Limpiar campos
      this.bulkEdit.massDiscountPercentage = null;
      this.bulkEdit.massSalePercentage = null;

      this.showAlert('success', 'Éxito', `Se aplicaron los valores a ${this.bulkEdit.products.length} productos. Presione "Guardar Cambios" para confirmar.`);
    },

    onFamilyChange(familyId) {
      // Filtrar categorías según la familia seleccionada
      this.bulkEdit.categoryFilter = '';
      this.bulkEdit.subcategoryFilter = '';
      this.bulkEdit.subcategoryOptions = [];
      
      if (familyId) {
        this.bulkEdit.categoryOptions = this.categories
          .filter(category => category.id_family == familyId)
          .map(category => ({ name: category.name, value: category.id }));
      } else {
        this.bulkEdit.categoryOptions = [];
      }
    },

    onCategoryChange(categoryId) {
      // Filtrar subcategorías según la categoría seleccionada
      this.bulkEdit.subcategoryFilter = '';
      
      if (categoryId) {
        this.bulkEdit.subcategoryOptions = this.subcategories
          .filter(subcategory => subcategory.id_cat == categoryId)
          .map(subcategory => ({ name: subcategory.name, value: subcategory.id }));
      } else {
        this.bulkEdit.subcategoryOptions = [];
      }
    },

    clearBulkEditFilters() {
      this.bulkEdit.familyFilter = '';
      this.bulkEdit.categoryFilter = '';
      this.bulkEdit.subcategoryFilter = '';
      this.bulkEdit.categoryOptions = [];
      this.bulkEdit.subcategoryOptions = [];
    },

    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },

    closeAlert() {
      this.alert.show = false;
    },

    acceptAlert() {
      this.alert.show = false;
    }
  },
}
</script>

<style>
/* Estilos globales para componentes Vuetify dentro de editable-field */
.editable-field input {
  text-align: right !important;
  padding-right: 8px !important;
}

.editable-field .v-input__slot {
  padding: 0 !important;
}

.editable-field .v-text-field__slot input {
  text-align: right !important;
}
</style>

<style scoped>
.show .v-list-item {
  min-height: auto !important;
}

.filter-btn {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 9;
}


.btn-add {
  background-color: #3498DB !important;
  color: white;
}

.btnsave {
  background-color: #00A178 !important;
  color: white;
}

.btnclean {
  background-color: #F29D35 !important;
  color: white;
}

.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}

.btndelete {
  background-color: #E3191E !important;
  color: white;
}

.justified-column {
  width: 100%;
  border: 1px solid #ccc;
  /* Solo para visualizar el contenedor */
  padding: 10px;
  /* Espaciado interno */
  word-wrap: break-word;
  /* Permite el salto de palabras */
  
}

.component-v-card{
  border-radius: 15px;
}

.product-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 100%;
  flex-wrap: wrap;
  padding: 2px 0;
}

.product-action-btn {
  width: 34px !important;
  height: 34px !important;
  min-width: 34px !important;
  border-radius: 17px;
  border: 1px solid transparent;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.product-action-btn .v-icon {
  font-size: 18px !important;
}

.product-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.12);
}

.product-action-btn:focus-visible {
  outline: none;
  border-color: #90caf9;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.18);
}

.product-action-btn--view {
  color: #1976d2 !important;
  border-color: rgba(25, 118, 210, 0.14);
}

.product-action-btn--price {
  color: #00897b !important;
  border-color: rgba(0, 137, 123, 0.14);
}

.product-action-btn--codes {
  color: #5e35b1 !important;
  border-color: rgba(94, 53, 177, 0.14);
}

.product-action-btn--stock {
  color: #ef6c00 !important;
  border-color: rgba(239, 108, 0, 0.14);
}

.product-action-btn:hover .v-icon {
  transform: scale(1.06);
}

.editable-field {
  margin: 0 !important;
  padding: 0 !important;
}

.editable-field .v-input__control {
  min-height: auto !important;
}

.editable-field .v-text-field__details {
  display: none !important;
}

.editable-field input {
  text-align: right !important;
}

.editable-cell-view {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.editable-cell-view:hover {
  background-color: #e3f2fd;
}

.editable-cell-view .edit-icon {
  font-size: 14px !important;
  color: #1976d2;
  opacity: 0.6;
  margin-right: 6px;
}

.editable-cell-view:hover .edit-icon {
  opacity: 1;
}

.editable-cell-view .cell-value {
  font-size: 13px;
}

/* Alineación para columnas del DataGrid */
.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}
</style>
